import { useQuery } from '@tanstack/react-query';
import { ResponseObject } from '../../interfaces/App';
import Company from '../../interfaces/Company';
import { getCompany } from '../../services/companyService';

interface CompanyResponse extends Omit<ResponseObject, 'message'> {
  message: Company | null;
}

export const useCompanyQuery = (
  companyId: string | undefined,
  enabled = true
) => {
  return useQuery<ResponseObject, Error, CompanyResponse>({
    queryKey: ['company', companyId],
    queryFn: async (): Promise<ResponseObject> => {
      if (!companyId) {
        return { status: 'error', message: null };
      }
      const result = await getCompany(companyId);
      return result || { status: 'error', message: null };
    },
    enabled: enabled && !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    select: data => ({
      ...data,
      message: data.message as Company,
    }),
  });
};
